import { useAuthenticatedSession } from '@/authenticatedSession/AuthenticatedSessionContext';
import { useFirm } from '@/database/hooks/hooks';
import { LoadingOverlay, Paper, Stack, Switch, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import CollapsibleDevPanelSection from './CollapsibleDevPanelSection';

const DemoModeSection = () => {
  const { firm } = useFirm();
  const authSession = useAuthenticatedSession();
  const [aragDemo, setAragDemo] = useState<boolean>(!!firm?.demoFlags?.arag);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);

  useEffect(() => {
    setAragDemo(!!firm?.demoFlags?.arag);
  }, [firm?.demoFlags?.arag]);

  const handleChange = async (value: boolean) => {
    if (!authSession) return;
    setIsLoading(true);
    setError(undefined);
    try {
      const nextDemoFlags = { ...(firm?.demoFlags ?? {}), arag: value };
      await authSession.db.updateFirm({ demoFlags: nextDemoFlags });
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Unknown error');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <CollapsibleDevPanelSection title='Demo Modes'>
      <Stack gap='sm' pos='relative'>
        {isLoading && <LoadingOverlay visible={isLoading} />}
        <Switch
          label='Enable ARAG demo mode'
          checked={aragDemo}
          onChange={(e) => handleChange(e.currentTarget.checked)}
          disabled={isLoading}
          labelPosition='right'
        />
        {error && (
          <Text c='red' size='sm'>
            Error: {error}
          </Text>
        )}
      </Stack>
    </CollapsibleDevPanelSection>
  );
};

export default DemoModeSection;
